export enum MessageKeys {
    COPY_ID = 'COPY_ID',
    COPY_DEEP_LINK = 'COPY_DEEP_LINK',
    SYNC_ERROR = 'SYNC_ERROR',
    SYNC_SUCCESS = 'SYNC_SUCCESS',
    NO_CHANGES_MADE = 'NO_CHANGES_MADE',
}
